var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-layout",
    {
      staticStyle: { "margin-top": "10%" },
      attrs: {
        wrap: "",
        row: "",
        "justify-center": "",
        "fill-height": "",
        "align-center": ""
      }
    },
    [
      _c(
        "v-flex",
        { staticClass: "text-xs-center", attrs: { xs12: "", sm6: "" } },
        [
          _c("img", {
            staticClass: "logo",
            attrs: {
              src: "https://s3.us-east-2.amazonaws.com/binxudata/logo.gif"
            }
          })
        ]
      ),
      _vm._v(" "),
      _c(
        "v-flex",
        { staticClass: "text-xs-right", attrs: { xs12: "" } },
        [
          _c(
            "v-btn",
            {
              staticStyle: { "margin-top": "-10%", "margin-right": "10%" },
              attrs: { dark: "", color: "black", to: "/welcome" }
            },
            [_vm._v("Learn More")]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-a8baa566", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a8baa566","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/Landing.vue
// module id = null
// module chunks = 